import { render, staticRenderFns } from "./dialPrice.vue?vue&type=template&id=565962ab&"
import script from "./dialPrice.vue?vue&type=script&lang=js&"
export * from "./dialPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports